import { useTranslation } from 'react-i18next'

import { Sheet } from './sheet'
import { CitySearch } from './city-search'
import type { DiscoveryLocation } from '../types'

interface CityPickerSheetProps {
  open: boolean
  onClose: () => void
  onSelect: (location: DiscoveryLocation) => void
  onDetectLocation: () => Promise<void>
}

export function CityPickerSheet({
  open,
  onClose,
  onSelect,
  onDetectLocation,
}: CityPickerSheetProps) {
  const { t } = useTranslation()
  return (
    <Sheet
      open={open}
      onClose={onClose}
      titleKey="discovery.city.title"
      size="tall"
    >
      {open ? (
        <CitySearch
          focusOnMount
          onSelect={(location) => {
            onSelect(location)
            onClose()
          }}
          onLocate={async () => {
            await onDetectLocation()
            onClose()
          }}
        />
      ) : (
        <span className="sr-only">{t('common.loading')}</span>
      )}
    </Sheet>
  )
}
